
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources03On as ObiSources03OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-03-on.js';
 
 
 

 
 export const ObiSources03On = createComponent({
   react: React,
   tagName: 'obi-sources-03-on',
   elementClass: ObiSources03OnElement,
   events: {
     
   }
  });
 
 